// ** React Imports
import { useEffect, useState } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'

import IconButton from '@mui/material/IconButton'

// ** Custom Components
import TableView from './TableView';
// import moment from 'moment-timezone'
import { useNavigate } from "react-router-dom";
import { openModal } from 'components/Modal/services';
import { useDispatch } from 'react-redux';
import editIcon from "assests/edit-icon.png";
import viewIcon from "assests/view-icon.png";
import deleteIcon from "assests/delete-icon.png";
import { CenteredLoader, pageConfig } from 'utils/constant';
import ConfirmationDialog from 'components/Modal/ConfirmationDialog/ConfirmationDialog';

export const Table = ({
    columns,
    apiHook,
    initialValues,
    validationSchema,
    title,
    formFields,
    deleteApiHook,
    pageId,
    viewFields,
    searchBy,
    isViewVisible,
    rowHeight, 
}) => {
    // ** States
    const [searchValue, setSearchValue] = useState('');
    const [dateRange, setDateRange] = useState([new Date(), new Date()])
    const [customColumns, setCustomColumns] = useState(columns);
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 })
    const [show, setShow] = useState(false);
    const [viewData, setViewData] = useState(false);
    const [editValues, setEditValues] = useState(initialValues);
    const [updateList, setUpdateList] = useState(false);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
    const [itemToDelete, setItemToDelete] = useState(null)
    const [dialogOpen, setDialogOpen] = useState(false)
    const [currentCategory, setCurrentCategory] = useState(null)

    //   const [getList, { data, isLoading }] = apiHook(paginationModel.page + 1, searchValue);
    const  { data, isLoading } = apiHook({ page: paginationModel.page + 1, search: searchValue, limit: paginationModel.pageSize });
    const [deleteItem, {isLoading:isDeleteLoading}] = deleteApiHook();
   
    const [startDate, endDate] = dateRange
    const [isAddButtonVisible, setIsAddButtonVisible] = useState(true)
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const fetchTableData = (search, page) => {
        // getList({ page: page + 1, search});
    }

    // useEffect(() => {
    //     if (updateList) {
    //         fetchTableData(searchValue, paginationModel.page);
    //         setUpdateList(false);
    //     }
    // }, [updateList, searchValue, paginationModel]);


    useEffect(() => {

        setCustomColumns([
            ...customColumns,
            {
                headerName: "Actions",
                field: "action",
                sortable: false,
                sortable: false,
                minWidth: 130,
                // flex: 1,
                renderCell: ({ row }) => (
                    <Box sx={{ display: "flex", alignItems: "center", height:'100%' }}>
                            <IconButton size="small" sx={{ color: "green" }} onClick={() => editItem(row)}>
                                <img src={editIcon} alt='edit-icon' style={{width:'16px', height:'16px'}}/>
                            </IconButton>
                        {!isViewVisible && (pageId === "user-list"  || pageId === "category-list") ? '' :
                            <IconButton size="small" sx={{ color: "#7367F0" }} onClick={() => viewItem(row)}>
                                <img src={viewIcon} alt='view-icon' style={{width:'18px', height:'14px'}}/>
                            </IconButton>
                        }
                            <IconButton size="small" sx={{ color: "red" }} onClick={() => handleDelete(row)}>
              <img src={deleteIcon} alt="delete-icon" style={{ width: "14px", height: "16px" }} />
            </IconButton>
                    </Box>
                ),
                align: 'center',
                // headerAlign: 'center'
            }
        ])

    }, []);

    useEffect(() => {
        const debounceTimer = setTimeout(() => {
            fetchTableData(searchValue, paginationModel.page)
        }, 800);

        return () => {
            clearTimeout(debounceTimer);
        };
    }, [searchValue]);

    const handleSearch = e => {
        setSearchValue(e.target.value);
    }

    const clearSearch = () => {
        setSearchValue('');
    }

    const closeForm = () => {
        setShow(false, () => {
            setEditValues(initialValues);
        });
    }

    const closeView = () => {
        setViewData(false);
        setEditValues(initialValues);
    }

    const navigateTo = (action, data = {}) => {
        const config = pageConfig[pageId];
        if (!config) return;
    
        const path =
            action === "add"
                ? config.addPath
                : action === "edit" && config.editPath
                ? typeof config.editPath === "function"
                    ? config.editPath(data.id)
                    : config.editPath
                : action === "view" && config.viewPath
                ? typeof config.viewPath === "function"
                    ? config.viewPath(data.id)
                    : config.viewPath
                : null;
        if (path) {
            navigate(path, { state: { ...data } });
        }
    };
    

    const addNew = () => {
       
        navigateTo("add", { initialValues });
        setEditValues(initialValues);
        setShow(true);
    };
    
    const editItem = (rowData) => {
        handleEdit(rowData)
        navigateTo("edit", { data: rowData });
    };
    const handleEdit = (category) => {
        setCurrentCategory(category)
        setDialogOpen(true)
      }
    
    const viewItem = (rowData) => {
        navigateTo("view", { data: rowData });
        setViewData(true);
    };

    // const handleDelete = (data, title) => {
    //     const modifyData = {...data, pageId: pageId}
    //     dispatch(openModal({content:'confirmModal', data: modifyData}));
    // }
     // New method to handle delete confirmation
  const handleDelete = (data) => {
    setItemToDelete(data)
    setConfirmDialogOpen(true)
  }

  // New method to handle confirmation
  const handleConfirmDelete = () => {
    if (itemToDelete) {
      // Call your delete API
      deleteItem(itemToDelete.id)
        .then(() => {
          // Refresh the table data after successful deletion
          setUpdateList(true)
          setConfirmDialogOpen(false)
        })
        .catch((error) => {
          console.error("Error deleting item:", error)
          setConfirmDialogOpen(false)
        })
    }
  }

    const customLocaleText = {
        noRowsLabel: `No Records found`, // Change this line to customize the message
    };
 // Handle closing the dialog
 const handleCloseDialog = () => {
    setDialogOpen(false)
    setCurrentCategory(null)
  }


    return (
        <>
            {isLoading ? (
                <CenteredLoader />
            ) : (
                <TableView
                    // isLoading={isLoading || data === undefined}
                    columns={customColumns}
                    rows={data?.data?.records ?? []}
                    total={data?.data?.totalCount ?? 0}
                    paginationModel={paginationModel}
                    setPaginationModel={setPaginationModel}
                    searchValue={searchValue}
                    handleSearch={handleSearch}
                    clearSearch={clearSearch}
                    initialValues={editValues}
                    validationSchema={validationSchema}
                    // addUpdate={addUpdate}
                    show={show}
                    addNew={addNew}
                    closeForm={closeForm}
                    title={title}
                    formFields={formFields}
                    fetchTableData={fetchTableData}
                    viewData={viewData}
                    closeView={closeView}
                    //   updateData={deleteApiHook}
                    customLocaleText={customLocaleText}
                    pageId={pageId}
                    isAddButtonVisible={isAddButtonVisible}
                    viewFields={viewFields}
                    searchBy={searchBy}
                    rowHeight={rowHeight} // <-- passing rowHeight to TableView
                />
                
            )}
             {/* Confirmation Dialog */}
          <ConfirmationDialog
            open={confirmDialogOpen}
            handleClose={() => setConfirmDialogOpen(false)}
            handleConfirm={handleConfirmDelete}
            btnText="Delete"
            infoText={`Are you sure you want to delete this ${title}?`}
            isLoading={isDeleteLoading}
          />
        </>
    )
}